<template>
  <footer class="footer col-12" :class="{ 'd-lg-none': !showDangerScale }">
    <div class="row h-100 parent-row">
      <div v-if="showDangerScale" class="col danger-scale-wrapper">
        <div class="row h-100 align-items-center">
          <div class="col-10">
            <DangerScale :responsive="false" />
          </div>
        </div>
      </div>
      <div class="col-auto share-button d-md-block d-sm-block d-lg-none d-xl-none">
        <div class="row h-100 m-0 align-items-center justify-content-end">
          <div class="col-auto pr-2">
            <span class="tile__heading tile__heading--title m-0 p-0">Public observations</span>
          </div>
          <div class="col-auto">
            <Button
              :styles="{ 'button--public-obs--purple': true, 'text-truncate': true }"
              :onClick="handleObservationButtonClick"
            >
              <span slot="label">
                <PublicMarker :styles="{ 'd-inline-block': true, 'align-middle': true }" />
                <span class="d-inline-block align-middle">Share now</span>
              </span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import Button from "../button/Button";
import DangerScale from "../danger-scale/DangerScale";
import PublicMarker from "../public-marker/PublicMarker";

import { mapState } from "vuex";

export default {
  components: {
    Button,
    DangerScale,
    PublicMarker
  },

  props: {
    dangerScaleLink: {
      type: String
    },
    showDangerScale: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapState({
      cms: state => state.cms
    })
  },

  methods: {
    handleObservationButtonClick(event) {
      this.$router.push({ name: "observationform" });
    }
  }
};
</script>
